'use client';

import { Select } from '@lichtblick/photon/molecules/select';

type CityInputProps = {
  cities: { cityId: string; cityName: string | null }[];
  label?: string;
  defaultCity?: string;
  defaultCityId?: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  errorMessage?: string;
};

export const CityInput: React.FC<CityInputProps> = ({
  cities,
  defaultCityId,
  defaultCity,
  name,
  label,
  onChange,
  errorMessage,
}) => (
  <>
    <Select
      data-testid="select-cityId"
      value={defaultCityId ?? ''}
      emptyOptionLabel={cities.length === 0 ? 'Bitte auswählen' : undefined}
      errorMessage={errorMessage}
      label={label ?? 'Ort'}
      name="cityId"
      onInvalid={(e) => {
        e.preventDefault();
      }}
      onChange={onChange}
      required
    >
      {[
        ...(cities.length > 1
          ? [
              <Select.Option hidden key="placeholder" value="">
                Bitte auswählen
              </Select.Option>,
            ]
          : []),
        ...(cities ?? []).map((city) => (
          <Select.Option key={city.cityId} value={city.cityId ?? ''}>
            {city.cityName}
          </Select.Option>
        )),
      ]}
    </Select>
    <input type="hidden" data-testid={`hidden-input-${name}`} name={name} value={defaultCity ?? ''} />
  </>
);
